import type { UseMutationResult } from '@tanstack/react-query'
import { useIsMutating, useMutation } from '@tanstack/react-query'
import type { AxiosResponse } from 'axios'

import { getMfrrEnergyBid } from '@/features/bidding/endpoints/bids'
import type { UseMutationOptions } from '@/types/queries'

const GET_MFRR_ENERGY_BID = 'GET_MFRR_ENERGY_BID'

type GetMfrrEnergyBid = {
  countryCode: string
  deliveryDay: string // ISO date string
}

export type UseGetMfrrEnergyBidMutationResult = Omit<
  UseMutationResult<AxiosResponse<string>, Error, GetMfrrEnergyBid>,
  'mutateAsync'
> & {
  getMfrrEnergyBid: UseMutationResult<AxiosResponse<string>, Error, GetMfrrEnergyBid>['mutateAsync']
}

export function useGetMfrrEnergyBidMutation(
  options?: UseMutationOptions<AxiosResponse<string>, GetMfrrEnergyBid>,
): UseGetMfrrEnergyBidMutationResult {
  const { mutateAsync, ...mutationResult } = useMutation({
    ...options,
    mutationFn: (variables: GetMfrrEnergyBid) => getMfrrEnergyBid(variables.countryCode, variables.deliveryDay),
  })

  return { getMfrrEnergyBid: mutateAsync, ...mutationResult }
}

export const useIsGettingMfrrEnergyBid = (): boolean => useIsMutating({ mutationKey: [GET_MFRR_ENERGY_BID] }) > 0
